import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { isDataAvailable, isEmptyField } from '../vl_util_functions/common-utils';
import { VlDateFormatService } from './vl-date-format.service';
import { ProjConstants } from '../../constants/proj.cnst';

@Injectable({
  providedIn: 'root'
})
export class VlParamsService {

  constructor(
    private dateFormatService: VlDateFormatService
  ) { }

  public getParams(params: Params, id ?: string) {
    let returnParams: Params = {};
    if(id){
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          const actualParamArray = param.split(id + ProjConstants.PARAM_SEPARATOR);

          if (actualParamArray.length > 1) {
            returnParams[actualParamArray[1]] = params[param];
          }
        }
      }
    }else{
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          returnParams[param] = params[param];
        }
      }
    }
    return returnParams;
  }

  public getParamsFromRouteSnapshot(params: Params) {
    let returnParams: Params = {};
    for (const param in params) {
      if (params.hasOwnProperty(param)) {
        const actualParamArray = param.split(ProjConstants.PARAM_SEPARATOR);
        let actualParam = param;
        if (actualParamArray.length > 1) {
          actualParam = actualParamArray[1];
        }
        returnParams[actualParam] = params[param];
      }
    }
    return returnParams;
  }

  getWritableObject(obj: any): any{
    if(!isDataAvailable(obj)) return obj;
    let objectConfig: any = {};
    for(let key in obj){
      objectConfig[key] = obj[key];
    }
    return objectConfig;
  }

  verifyAllParamsPresent(queryParams: Params, verificationArray: string[]) {
    let isAllPresent = true;
    verificationArray.forEach(value => {
      if (!isAllPresent) {
        return;
      }
      if (!queryParams.hasOwnProperty(value)) {
        isAllPresent = false;
      }
    });
    return isAllPresent;
  }

  formParamsFromTheQueryParams(params: { [x: string]: any; }, id?: string) {
    const finalParams: any = {};
    if (!isEmptyField(params)) {
      for (const param of Object.keys(params)) {
        const paramValue = params[param];
        finalParams[param] = paramValue;
        if (param === 'startDate' || param === 'endDate') {
          if (paramValue === 'today') {
            finalParams[param] = this.dateFormatService.formatFromNewDate(new Date(), 'yyyymmdd');
          } else if (paramValue === 'default') {
            let date = new Date()
            date.setMonth(0)
            date.setDate(1)
            date.setFullYear(2022);
            finalParams[param] = this.dateFormatService.formatFromNewDate(date, 'yyyymmdd');
          } else if (paramValue === 'enddefault') {
            let date = new Date()
            date.setMonth(11)
            date.setDate(31)
            date.setFullYear(2022);
            finalParams[param] = this.dateFormatService.formatFromNewDate(date, 'yyyymmdd');
          }
        }
      }
    }
    return id && !isEmptyField(id) ? this.setParams(finalParams, id) : finalParams;
  }

  public setParams(params: Params, id: string) {
    let returnParams: Params = {};
    for (const param in params) {
      if (params.hasOwnProperty(param)) {
        const actualParamName = id + ProjConstants.PARAM_SEPARATOR + param;
        returnParams[actualParamName] = params[param];
      }
    }
    return returnParams;
  }
}
